import { create } from 'zustand';
import type { SearchFilters, Customer } from '../types';

interface FiltersState {
  filters: SearchFilters;
  searchResults: Customer[];
  selectedCustomerId: string | null;
  setFilters: (filters: Partial<SearchFilters>) => void;
  clearFilters: () => void;
  setSearchResults: (customers: Customer[]) => void;
  setSelectedCustomerId: (id: string | null) => void;
}

export const useFiltersStore = create<FiltersState>((set) => ({
  filters: {},
  searchResults: [],
  selectedCustomerId: null,

  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),

  clearFilters: () =>
    set({
      filters: {},
      searchResults: [],
    }),

  setSearchResults: (customers) =>
    set({
      searchResults: customers,
    }),

  setSelectedCustomerId: (id) =>
    set({
      selectedCustomerId: id,
    }),
}));
